<app-dialog
        [(visible)]="visible"
        [headerTitle]="'Ver Demandas Nesta Localização'"
        width="70vw"
>
    <div class="p-dialog-content">
        <p class="modal-intro-text font-medium text-base leading-tight text-gray-700 mb-2">
            Nesta localização as seguintes demandas já foram criadas:
        </p>

        <p-treeTable
                (onNodeExpand)="onNodeExpand($event)"
                [lazy]="false"
                [loading]="false"
                [paginator]="true"
                [rowsPerPageOptions]="[10, 25, 50]"
                [rows]="10"
                [showLoader]="false"
                [value]="treeDemands"
                currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} entradas"
                dataKey="key"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th scope="col" style="width: 3rem"></th>
                    <th scope="col">Tipo da Obra</th>
                    <th scope="col">Autor</th>
                    <th scope="col">Data</th>
                    <th scope="col">Protocolo</th>
                    <th scope="col">Situação</th>
                    <th scope="col" class="flex justify-center items-center">Ações</th>
                </tr>
            </ng-template>

            <ng-template let-rowData="rowData" let-rowNode pTemplate="body">
                <tr [ttRow]="rowNode">
                    <td>
                        @if (rowNode?.disabled === false) {
                            <span pTooltip="Reforços da Demanda">
                <p-treeTableToggler [rowNode]="rowNode"/>
              </span>
                        } @else {
                            <p-treeTableToggler [rowNode]="rowNode"/>
                        }
                    </td>
                    <td>{{ rowData.tipoObra }}</td>
                    <td>{{ rowData.autor }}</td>
                    <td>{{ rowData.data | datePtbr }}</td>
                    <td>{{ rowData.protocolo }}</td>
                    <td>{{ rowData.situacao }}</td>
                    <td>
                        <div class="flex flex-col md:flex-row gap-2 items-center justify-center">
                            <p-button (click)="visualizarDemanda(rowData)"
                                (keydown.enter)="$event.preventDefault(); visualizarDemanda(rowData)"
                                (keydown.space)="$event.preventDefault(); visualizarDemanda(rowData)" ariaLabel="Visualizar" pTooltip="Visualizar"
                                      styleClass="btn-icon"
                                      tooltipPosition="left">
                                <app-icon-eye/>
                            </p-button>
                            @if (!rowNode.parent) {
                                <p-button (click)="abrirModalReforcarDemanda(rowData)"
                                    (keydown.enter)="$event.preventDefault(); abrirModalReforcarDemanda(rowData)"
                                    (keydown.space)="$event.preventDefault(); abrirModalReforcarDemanda(rowData)" ariaLabel="Reforçar Demanda"
                                          pTooltip="Reforçar Demanda"
                                          styleClass="btn-icon"
                                          tooltipPosition="left">
                                    <app-icon-location-add/>
                                </p-button>
                            } @else {
                                <p-button ariaLabel="Reforçar Demanda" disabled
                                          pTooltip="Não é possível reforçar novamente"
                                          styleClass="btn-icon" tooltipPosition="left">
                                    <app-icon-location-add color="#858796"/>
                                </p-button>
                            }
                        </div>
                    </td>
                </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
                @if (isLoading()) {
                    @for (i of [1, 2, 3]; track $index) {
                        <tr>
                            @for (column of [1, 2, 3, 4, 5, 6, 7]; track $index) {
                                <td>
                                    <p-skeleton height="1.5rem" width="100%"></p-skeleton>
                                </td>
                            }
                        </tr>
                    }
                } @else {
                    <tr>
                        <td colspan="7">Nenhuma demanda para exibir nesta localização.</td>
                    </tr>
                }
            </ng-template>
        </p-treeTable>
    </div>

    <div class="flex gap-2" footer>
        <p-button (onClick)="fecharModal()"
            (keydown.enter)="$event.preventDefault(); fecharModal()"
            (keydown.space)="$event.preventDefault(); fecharModal()" [disabled]="isLoading()" label="Fechar" styleClass="btn-outlined">
            <app-icon-bold-close-square/>
        </p-button>
    </div>
</app-dialog>

@if (showReforcarDemandaDialog) {
    <app-visualizar-reforcar-demanda-dialog (refresh)="onReforcarDemandaSuccess()"
                                            [(visible)]="showReforcarDemandaDialog"
                                            [demandaId]="demandaSelecionadaId"
                                            [editMode]="true"
                                            [mode]="'reforcar'"></app-visualizar-reforcar-demanda-dialog>
}
@if (showVisualizarDemandaDialog) {
    <app-visualizar-reforcar-demanda-dialog [(visible)]="showVisualizarDemandaDialog"
                                            [demandaId]="demandaSelecionadaId"
                                            [editMode]="false"
                                            [mode]="'visualizar'"></app-visualizar-reforcar-demanda-dialog>
}
